module.exports = __webpack_public_path__ + "static/media/bottlings6.f763c732.jpg";